<template>
  <fee-form :edit="edit" :stepper="true" @added="afterSave" @updated="afterSave" @cancel="backToList" />
</template>

<script>
import { mapState } from 'vuex';

import { wizardStepMixin } from '@/mixins/wizardStep';
import FeeForm from '@/components/forms/FeeForm';

// @vuese
// Podstawowe dane składki
export default {
  mixins: [wizardStepMixin('fee')],
  props: {
    // Czy formularz edycji
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    FeeForm
  },
  computed: mapState({
    entityType: state => state.fee.entityType
  }),
  methods: {
    // @vuese
    // Powrót do listy składek
    backToList() {
      this.$router.push({ name: `${this.entityType}Fees` });
    }
  }
};
</script>
